import React, {useState, useEffect} from "react"
import moment from "moment"

import styled from "styled-components"
// Colors
import {extended} from "@uprise/colors"
// Components
//import {TextStyled} from "@uprise/text"
import {Row, Col} from "@uprise/grid"

const HR = styled.div`
	width: 100%;
	height: 1px;
	background: ${extended.purple.five};
	margin: 5px 0;
`

const TextStyled = styled.div`
	color: ${extended.charcoal.one};
	overflow-wrap: break-word;
`

const ExpandBtn = styled.span`
	color: ${extended.purple.one};
	font-weight: bold;
	cursor: pointer;
	margin-left: 5px;
`

const NotesSummary = ({coachName, date, note, createdAt = null}) => {
	const [trimmedNote, setTtrimmedNote] = useState(note)
	const [collapsed, setCollapsed] = useState(true)

	useEffect(() => {
		if (note.length > 256) setTtrimmedNote(note.substring(0, 256))
	}, [note])

	const handleExpand = () => {
		if (trimmedNote.length <= 256) {
			setTtrimmedNote(note)
			setCollapsed(false)
		} else {
			setTtrimmedNote(note.substring(0, 256))
			setCollapsed(true)
		}
	}

	return (
		<>
			<Row>
				<Col className='col-2 col-lg-2'>
					<TextStyled className='m-t-0 m-b-3'>{coachName}</TextStyled>
				</Col>
                {createdAt &&
                    <Col className='col-2 col-lg-2'>
                        <TextStyled>{moment(createdAt).format("DD-MMM-YYYY,")}</TextStyled>
                        <TextStyled>{moment(createdAt).format("hh:mm A")}</TextStyled>
                    </Col>
                }
				<Col className='col-2 col-lg-2'>
					<TextStyled>{moment(date).format("DD-MMM-YYYY,")}</TextStyled>
					<TextStyled>{moment(date).format("hh:mm A")}</TextStyled>
				</Col>
				<Col className='col-6 col-lg-6'>
					<TextStyled>
						{trimmedNote}
						{note.length > 256 && (
							<ExpandBtn onClick={handleExpand}>{collapsed ? "More..." : "Less"}</ExpandBtn>
						)}
					</TextStyled>
				</Col>
			</Row>
			<HR />
		</>
	)
}
export default NotesSummary
